module.exports = __webpack_public_path__ + "img/tie-dye.3e967a92.jpg";